import React, { useState, Suspense } from 'react';
import { FormContainer } from '../CreateForm.styles';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
const ResultModal = React.lazy(
  () => import('../../../Components/Modal/ResultModal.component')
);
const UserInput = React.lazy(
  () => import('../../../Components/UserForm/UserInputs.component')
);
const CreateUserSubmit = React.lazy(() => import('./UserCreateSubmit'));

const CreateUser = () => {
  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  });
  const [isOpen, setIsOpen] = useState(false);
  const [successState, setSuccessState] = useState('');
  const validForm = Object.values(user).every((value) => value.trim() !== '');

  return (
    <AuthCheckAdmin>
      <HelmetHelper title="Create User" description="Form to create a user" />
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Admin Dashboard"
            oneLink="/admin"
            two="Create User"
          />
        </Suspense>
        <h2>CREATE USER</h2>
        <form>
          <Suspense fallback={<p>Loading user inputs...</p>}>
            <UserInput user={user} setUser={setUser} />
          </Suspense>
          <Suspense fallback={<p>Loading result modal...</p>}>
            <ResultModal
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              result={successState}
              linkTo="/admin"
            />
          </Suspense>
          <Suspense fallback={<p>Loading submit button...</p>}>
            <CreateUserSubmit
              user={user}
              setIsOpen={setIsOpen}
              setSuccessState={setSuccessState}
              disabled={validForm}
              successState={successState}
            />
          </Suspense>
        </form>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default CreateUser;
